// extracted by mini-css-extract-plugin
export default {"imageClass":"ImageCarousel_imageClass__VGuyz","thumbnailClass":"ImageCarousel_thumbnailClass__aPihJ","closeIcon":"ImageCarousel_closeIcon__35h4+"};